import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CreateOverlayDocument } from './create.generated';

export const useCreateOverlay = (options: ApiOptions<typeof CreateOverlayDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(CreateOverlayDocument, {
    ...useNotifications(CreateOverlayDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.overlays.create_success'),
    }),
    ...options,
  });
};
